import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ReaderPdfComponent } from '../../../shared/inputs/reader-pdf/reader-pdf.component';
import { PdfReader } from '../../../shared/models/pages-model/form-general.model';

@Component({
  selector: 'app-pdf',
  standalone: true,
  imports: [ReaderPdfComponent],
  templateUrl: './pdf.component.html',
})
export class PdfComponent {
  public quotationId!: string;
  public field: PdfReader | null = null;

  constructor(private route: ActivatedRoute) {
    this.field = {
      label: 'label',
      roleType: 'reader-PDF',
      fieldName: 'reader-PDF',
      colFull: true,
      value: '',
      idControl: 0,
      idFullControl: `0`,
      disabled: false,
      error: {},
      rules: [],
      quotationId: 604,
      url: '',
      view: true,
      typeInput: 'reader-PDF',
      order: 0,
      functionEvent: {
        event: {
          function: null,
          starFuntion: false,
          eventFuntion: false,
        },
        catalog: {
          url: null,
          nameParam: null,
          input: null,
          arrayParam: [],
        },
        ulrPDF: 'plantilla-dealer',
      },
    };

    this.route.queryParams.subscribe((params) => {
      this.quotationId = params['quotationId'];
      this.field!.quotationId = Number(this.quotationId);
    });
  }
}
